import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'react-mdc-web';
import { LEDGERS } from '../../../../data/enums/enums';
import { fixedFloatAndCommas } from '../../../../utils/conversion';

class CreateServiceInvoiceTableBody extends Component {
  render() {
    const { data, index } = this.props;
    return (
      <tr>
        <td>{index + 1}</td>
        <td>{data.skuTitle}</td>
        <td>{data.particulars}</td>
        <td className='right-align'>{data.quantity}</td>
        <td className='right-align'>{fixedFloatAndCommas(data.rate)}</td>
        <td className='right-align'>{fixedFloatAndCommas(data.amount)}</td>
        <td className='right-align'>
          <Icon name='edit' onClick={() => this.props.handleEditIconClick(data, index)} />
          <Icon name='delete' onClick={() => this.props.handleDeleteIconClick(index)} />
        </td>
      </tr>
    );
  }
}

CreateServiceInvoiceTableBody.defaultProps = { enableUpdate: true, };

CreateServiceInvoiceTableBody.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  handleDeleteIconClick: PropTypes.func.isRequired,
  handleEditIconClick: PropTypes.func.isRequired,
  enableUpdate: PropTypes.bool,
};

const createServiceInvoiceConfig = {
  headerDetails: [
    {
      id: 1,
      label: 'test',
      title: 'SN',
      className: null,
      sortable: false,
    },
    {
      id: 2,
      label: 'service',
      title: 'Service',
      className: null,
      sortable: false,
    },
    {
      id: 10,
      label: 'particulars',
      title: 'Description',
      className: null,
      sortable: false,
    },
    {
      id: 3,
      label: 'quantity',
      title: 'Quantity',
      className: 'right-align',
      sortable: false,
    },
    {
      id: 4,
      label: 'rate',
      title: 'Rate',
      className: 'right-align',
      sortable: false,
    },
    {
      id: 6,
      label: 'amount',
      title: 'Amount',
      className: 'right-align',
      sortable: false,
    },
    {
      id: 9,
      label: 'test',
      title: '',
      className: 'right-align',
      sortable: false,
    },
  ],
};

const discountOptions = [
  { value: 'per', label: 'in %' },
  { value: 'rs', label: 'in Rs' },
];

const message = {
  success: 'Service Invoice created successfully.',
  error: '!Error while creating Service Invoice',
  panNoRequiredError: 'PAN number required!',
  cashBillError: `CASH bill cannot exceed ${LEDGERS.CASH.validInvoiceAmount.toLocaleString()}`,
  invoiceListEmptyError: 'Invoice list is empty!',
  agent: 'Agent required!',
  promotionValidation: 'Promotion Validation Failed!',
};

const pageValidateFieldTypes = {
  cash: [],
  genuineCustomer: ['name', 'panNo'],
  customer: ['name'],
};

const customerType = {
  CUSTOMER: 'CUSTOMER',
  CASH: 'CASH',
};

export {
  createServiceInvoiceConfig,
  CreateServiceInvoiceTableBody,
  customerType,
  pageValidateFieldTypes,
  message,
  discountOptions,
};
